import React, { useEffect, Suspense, lazy } from 'react';
import { useSelector } from 'react-redux';
import Loader from '../components/Loader';

const Footer = lazy(() => import('../components/Footer'));
const Logout = lazy(() => import('../components/Logout'));

// Updated loading component
const loading = () => <Loader title="Loading..." variant="fullscreen" />;

const DefaultLayout = ({ children }) => {
    const props = useSelector((state) => state); // assuming you need the entire state, adjust as needed
    const loadingState = useSelector((state) => state.Loading);

    useEffect(() => {
        if (window.location.pathname.indexOf('/register') === 0) {
            if (document.body) document.body.classList.add('register-wizard');
        } else {
            if (document.body) document.body.classList.add('authentication-bg');
        }

        return () => {
            if (document.body) {
                document.body.classList.remove('authentication-bg');
                document.body.classList.remove('register-wizard');
            }
        };
    }, []);

    return (
        <>
            <Suspense fallback={loading()}>
                <Logout {...props} />
            </Suspense>
            <Suspense fallback={loading()}>{children}</Suspense>
            <Suspense fallback={loading()}>
                <Footer {...props} />
            </Suspense>

            {/* Global Loading Overlay */}
            {loadingState.isLoading && (
                <div className="loading-overlay semi-transparent">
                    <Loader 
                        title={loadingState.title}
                        subtitle={loadingState.subtitle}
                        variant={loadingState.variant}
                    />
                </div>
            )}
        </>
    );
};

export default DefaultLayout;
